export const MAX_REGISTRATION_LIMIT_SIMULIVE = 30000;

export const ASSET_ASSOCIATIONS = {
  REGISTRATION_ASSOCIATION: 'registrationAssociation',
  OBJ: 'obj'
};
